import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "@mui/system";

const Icon = styled(FontAwesomeIcon)({});

export default Icon;
